import "../styles/about.css"
import Header from '../components/Header';
import { useEffect } from "react"


function Donate() {
    return (<>
        <Header />
        <form className="donate" action="https://www.paypal.com/donate" method="post" target="_blank">
            <input type="hidden" name="hosted_button_id" value="TMTP4FSRT223E" />
            <button className="btn" id="donate-btn">DONATE</button>
        </form>
    </>
    )
}


export default Donate